// eslint-disable-next-line no-unused-vars
import request from '@/service/httpwithprogress'

export function upload(data, callback) {
    return request({
        url: '/api/upload',
        method: 'post',
        onUploadProgress: callback,
        data,
    })
}

export function uploadTest(data,callback) {
    return request({
        url: '/api/uploadTest',
        method: 'post',
        onUploadProgress: callback,
        data,
    })
}

export function uploadPublic(data,callback) {
    return request({
        url: '/api/uploadPublic',
        method: 'post',
        onUploadProgress: callback,
        data,
    })
}